import template from './new-building-material-type.jade';
import saleNewBuildingMaterialType from './../../../enums/material-type-new-building';
import { isValidEnum } from '../../../utils';
import validation from './../../../services/validation';

export default angular
    .module('cian.addForm.newBuildingMaterialType', [])
    .directive('cianAfAboutBuildingNewBuildingMaterialType', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller(deviceService) {
            'ngInject';

            this.isMobile = deviceService.isMobile;

            this.materialTypes = saleNewBuildingMaterialType;

            // удаляем невалидное значение, пришедшее из других категорий
            if (this.ad.building && !isValidEnum(this.materialTypes, this.ad.building.materialType)) {
              this.ad.building.materialType = undefined;
            }

            this.validation = validation(this.form, 'newBuildingMaterialType', {
                required: 'Выберите значение',
            });
        },
        controllerAs: 'newBuildingMaterialType',
        template,
    }))
    .name;
